import { getSimpleGood } from './api/good'
import { MarketingType } from './type'

/**
 * 订单状态选项
 * @returns 
 */
export const getOrderStatuses = () => {
  return [
    { label: '正在点单', value: '1' },
    { label: '用餐中', value: '2' },
    { label: '已结算', value: '4' },
    { label: '已取消', value: '16' },
    { label: '已退款', value: '32' },
  ] as CommonOption[]
}

/**
 * 营销类别选项
 * @returns 
 */
export const getMarketingCategories = () => {
  return [
    { label: '商品券', value: MarketingType.Good },
    { label: '满减券', value: MarketingType.FullReduce },
  ]
}

/**
 * 星期选项
 * @returns 
 */
export const getWeekday = () => {
  return [
    { label: '一', value: 1 },
    { label: '二', value: 2 },
    { label: '三', value: 3 },
    { label: '四', value: 4 },
    { label: '五', value: 5 },
    { label: '六', value: 6 },
    { label: '日', value: 7 },
  ]
}

/**
 * 获取菜单树
 * @param id 
 * @returns 
 */
export const getMenuTree = async (id?: string, menus?: SimpleGood[]): Promise<TreeData[]> => {
  if (!menus) {
    const { data } = await getSimpleGood(id)
    menus = data
  }
  const categories = $app.dic?.goodCategory.map(a => ({
    key: a.id ?? '',
    title: a.name,
    selectable: false,
    children: [] as TreeData[]
  })) ?? []
  categories.forEach(category => {
    category.children = menus.filter(a => a.category == category.key).map(a => ({
      key: a.id as string,
      title: `${a.name}(${a.code})`,
      ext1: a.img,
      selectable: true
    }))
  })
  return categories
}

/**
 * 日志类别
 */
export const logTypes = [
  { label: '全部', value: 0 },
  { label: '创建商品', value: 1 },
  { label: '修改商品', value: 2 },
  { label: '删除商品', value: 3 },
  { label: '上架商品', value: 4 },
  { label: '下架商品', value: 5 },
  { label: '复制商品', value: 6 },
  { label: '批量修改商品分类', value: 7 },
  { label: '生日礼券', value: 8 },
]

/**
 * 订单状态选项
 * @returns 
 */
export const getOutOrderStatuses = () => {
  return [
    { label: '已付款', value: '1' },
    { label: '已拒单', value: '2' },
    { label: '已接单', value: '4' },
    { label: '待取货', value: '8' },
    { label: '配送中', value: '16' },
    { label: '配送异常', value: '32' },
    { label: '已送达', value: '64' },
    { label: '已收货', value: '128' },
    { label: '未付款', value: '256' },
    { label: '已评价', value: '512' },
    { label: '已关闭', value: '1024' },
    { label: '取消配送', value: '2048' },
    { label: '支付超时', value: '4096' },
  ] as CommonOption[]
}

/**
 * 商城订单状态选项
 * @returns 
 */
export const getMallOrderStatuses = () => {
  return [
    { label: '未付款', value: 'NotPay' },
    { label: '已付款', value: 'Normal' },
    { label: '已发货', value: 'Sended' },
    { label: '已完成', value: 'Finish' },
    { label: '已取消', value: 'Cancel' },
    { label: '已退款', value: 'Refunded' }
  ] as CommonOption[]
}


export type ListNavigateKey = 'Today' | 'Yesterday' | 'Noon' | 'Afternoon' | 'Two' | 'Month' | 'NearMonth' | 'Custom'
/**
 * 获取列表导航树
 * @param items 默认的系统导航标题
 * @param type 搜索类型
 */
export const getListNavigateTree = (type?: string, items?: string[]) => {
  const navigates = [{
    title: '系统内置查询',
    key: 'InSystem',
    selectable: false,
    isEdit: false,
    canUse: false,
    isLeaf: false,
    closable: false,
    icon: 'icon-insystem',
    children: [
      { title: '今天的订单', icon: 'icon-today', key: 'Today', data: getQuery('Today'), isEdit: false, canUse: false, isLeaf: true, selectable: true, closable: false },
      { title: '昨天', icon: 'icon-zuotian', key: 'Yesterday', data: getQuery('Yesterday'), isEdit: false, canUse: false, isLeaf: true, selectable: true, closable: true },
      { title: '午市', icon: 'icon-noon', key: 'Noon', data: getQuery('Noon'), isEdit: false, canUse: false, isLeaf: true, selectable: true, closable: true },
      { title: '晚市', icon: 'icon-afternoon', key: 'Afternoon', data: getQuery('Afternoon'), isEdit: false, canUse: false, isLeaf: true, selectable: true, closable: true },
      { title: '两天内的订单', icon: 'icon-yesterday', key: 'Two', data: getQuery('Two'), isEdit: false, canUse: false, isLeaf: true, selectable: true, closable: true },
      { title: '本月的订单', icon: 'icon-month', key: 'Month', data: getQuery('Month'), isEdit: false, canUse: false, isLeaf: true, selectable: true, closable: true },
      { title: '近一月的订单', icon: 'icon-near-time', key: 'NearMonth', data: getQuery('NearMonth'), isEdit: false, canUse: false, isLeaf: true, selectable: true, closable: true },
    ]
  }, {
    title: '自定义查询',
    key: 'Custom',
    isLeaf: false,
    isEdit: false,
    selectable: false,
    canUse: false,
    icon: 'icon-custom',
    closable: false,
    platformSource: '',
    children: []
  }] as PageNavigate<OrderQuery>[]
  if (items?.length > 0) {
    navigates[0].children = navigates[0].children.filter(a => items.indexOf(a.key) > -1)
  }
  if (type) {
    navigates[1].children = getCustomNavigates(type)
  }
  return navigates
}

const getQuery = (flag: string) => {
  const obj = {
    storeIds: [],
    searchKey: '',
    staffIds: [],
    status: [],
    source: [],
    time: {
      timeField: 'CreatedTime',
      timeName: '下单时间',
      type: 1
    },
    pageIndex: 0,
    pageSize: 30,
    sortField: '',
    desc: true
  } as OrderQuery
  if (flag === 'Today') {
    obj.time.type = 1
  } else if (flag === 'Two') {
    obj.time.type = 2
  } else if (flag === 'Month') {
    obj.time.type = 3
  } else if (flag === 'NearMonth') {
    obj.time.type = 4
  } else if (flag === 'Noon') {
    obj.time.type = 5
  } else if (flag === 'Afternoon') {
    obj.time.type = 6
  } else if (flag === 'Yesterday') {
    obj.time.type = 7
  }
  return obj
}

/**
 * 获取自定义导航
 * @param type 搜索类型
 */
export const getCustomNavigates = (type: string) => $app.pageSettings.filter(a => a.type === type).map(a => ({
  key: a.id as string,
  title: a.name,
  data: JSON.parse(a.content) as OrderQuery,
  isEdit: true,
  canUse: true,
  isLeaf: true,
  setting: a,
  selectable: true,
  closable: true,
  icon: 'icon-search',
  children: []
}))
